<template>
  <div class="sticky w-full bg-gray-100 border-r" id="main-nav">
    <div class="flex flex-nowrap items-center text-primary pl-4 pt-2 rounded-lg cursor-pointer absolute -left-8"
      @click="store.toggleSidebar()">
      <AlignJustify class="mr-2" />
    </div>
    <div class="mb-4 px-4">
      <RouterLink to="/clinician"
        class="flex flex-nowrap items-center text-blue-400 h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/clinician' ? 'bg-secondary' : ''">
        <Home class="mr-2 text-primary" />
        <span class="text-gray-700 grow" v-if="sideBarOpen">Home</span>
      </RouterLink>
      <RouterLink to="/clinician/modules-to-review"
        class="flex flex-nowrap items-center text-blue-400 h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/clinician/modules-to-review'
          ? 'bg-secondary'
          : ''
          ">
        <NotebookText class="mr-2 text-primary" />
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">Modules To Review</span>
      </RouterLink>
      <RouterLink to="/clinician/unread-messages"
        class="flex flex-nowrap items-center text-blue-400 h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/clinician/unread-messages' ? 'bg-secondary' : ''
          ">
        <MessageSquareText class="mr-2 text-primary" />
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">Unread Messages <span class="text-red-500">{{
          unreadMessages.length > 0 ? unreadMessages.length : '' }}</span></span>
      </RouterLink>
      <RouterLink to="/clinician/users"
        class="flex flex-nowrap items-center text-blue-400 h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/clinician/users' ? 'bg-secondary' : ''
          ">
        <Users class="mr-2 text-primary" />
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">Users</span>
      </RouterLink>
      <RouterLink to="/clinician/event-logs"
        class="flex flex-nowrap items-center text-blue-400 h-10 p-4 hover:bg-secondary rounded-lg cursor-pointer"
        :class="$router.currentRoute.value.fullPath === '/clinician/event-logs' ? 'bg-secondary' : ''
          ">
        <Activity class="mr-2 text-primary" />
        <span class="text-gray-700 whitespace-nowrap" v-if="sideBarOpen">Event Logs</span>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSidebarStore } from '../stores/sidebar' // adjust the path to your store
import { useMessagesStore } from '@/stores/messages'
import { Home, NotebookText, MessageSquareText, Users, Activity, AlignJustify } from 'lucide-vue-next'

const store = useSidebarStore()
const messagesStore = useMessagesStore()

const sideBarOpen = computed(() => store.sidebar)
let unreadMessages = computed(() => messagesStore.unreadMessages)
</script>
